import { MAX_FILE_UPLOAD_SIZE_MB } from 'src/settings';

export function bytesToMbs({ bytes }: { bytes: number }) {
  if (bytes < 0 || isNaN(bytes) || !isFinite(bytes)) {
    return 0;
  }
  const megabytes = bytes / (1024 * 1024);
  const roundedMegabytes = megabytes.toFixed(2);

  return Number(roundedMegabytes);
}

export function isOverLimitedMb({ bytes }: { bytes: number }) {
  if (bytes < 0 || isNaN(bytes) || !isFinite(bytes)) {
    return false;
  }

  return bytes > 1024 * 1024 * MAX_FILE_UPLOAD_SIZE_MB;
}

export function checkIsAnyFileOver({
  files,
  setError
}: {
  files: File[];
  setError: (error: string) => void;
}): boolean {
  const largeFiles = filesLargeThanLimit({ files });

  if (largeFiles.length > 0) {
    setError(largeFilesMessage({ files: largeFiles }));

    return true;
  }

  return false;
}

export function filesLargeThanLimit({ files }: { files: File[] }) {
  return files.filter((file) => isOverLimitedMb({ bytes: file.size }));
}

export function largeFilesMessage({ files: largeFiles }: { files: File[] }) {
  const largeFilesNames = largeFiles.map((file) => file.name);

  return (
    `${largeFilesNames.join(', ')} exceeds the ${MAX_FILE_UPLOAD_SIZE_MB} MB limit. ` +
    `For bigger files, please upload to a cloud service such as Google Drive, Dropbox or WeTransfer, and email us at <a href="mailto:customers@cavela.com">customers@cavela.com</a>.`
  );
}

export function toastErrorIfFilesOverLimit({
  files,
  addToast
}: {
  files: File[];
  addToast: (toastParams: any) => void;
}): boolean {
  if (files.length > 0) {
    const largeFiles = filesLargeThanLimit({
      files: files.map((file: any) => file.file)
    });

    if (largeFiles.length > 0) {
      addToast({
        color: 'danger',
        title: (
          <span
            dangerouslySetInnerHTML={{
              __html: largeFilesMessage({ files: largeFiles })
            }}
          />
        )
      });

      return true;
    }
  }

  return false;
}
